var _rect, _rect2, _path, _path2, _path3, _rect3, _rect4, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVerifyOwnership = function SvgVerifyOwnership(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 60,
    viewBox: "0 0 112 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: -2,
    width: 60,
    height: 60,
    rx: 30,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: -2,
    width: 60,
    height: 60,
    rx: 30,
    stroke: "#181C2A",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6946 20.4204C21.9743 22.4684 20.9377 25.1106 20.9377 27.9951C20.9377 34.5031 26.2133 39.7787 32.7214 39.7787C35.6053 39.7787 38.2474 38.7421 40.2954 37.0218C40.7631 36.6297 41.4597 36.6904 41.8518 37.1581C42.244 37.6258 42.1832 38.3223 41.7156 38.7145C39.2834 40.7576 36.1208 41.9986 32.6956 41.9986C24.9681 41.998 18.7031 35.7336 18.7031 28.0049C18.7031 24.5797 19.9594 21.4325 22.0019 19.0003C22.3941 18.5326 23.0907 18.4718 23.5583 18.864C24.026 19.2562 24.0868 19.9528 23.6946 20.4204Z",
    fill: "#1066DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7261 15.8778C29.363 13.7813 33.8991 13.3382 38.0774 15.0689C40.8957 16.2362 42.2342 19.4675 41.0669 22.2857C39.8996 25.104 36.6683 26.4425 33.85 25.2752C32.347 24.6529 30.6236 25.3667 30.0007 26.8697C29.3784 28.3727 30.0922 30.0961 31.5952 30.719C32.4747 31.0836 33.4296 30.9903 34.1956 30.549C34.724 30.244 35.3997 30.425 35.7047 30.9535C36.0097 31.4819 35.8287 32.1576 35.3003 32.4626C33.9605 33.2353 32.2887 33.3986 30.7495 32.7609C28.119 31.6715 26.8701 28.6557 27.9594 26.0252C29.0488 23.3947 32.0647 22.1458 34.6951 23.2352C36.386 23.9354 38.3247 23.1327 39.025 21.4419C39.7253 19.751 38.9225 17.8123 37.2317 17.112C33.7132 15.6544 29.8933 16.0275 26.8302 17.7932C26.3018 18.0989 25.626 17.9178 25.321 17.3894C25.016 16.861 25.197 16.1853 25.7255 15.8802",
    fill: "#1066DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3876 19.1508C36.951 19.384 37.2192 20.0303 36.9854 20.5943C36.7515 21.1583 36.1059 21.4259 35.5419 21.192C32.8721 20.0873 29.6856 20.6182 27.5155 22.7884C24.6396 25.6643 24.6396 30.3274 27.5155 33.204C30.1766 35.8651 34.3678 36.0634 37.2572 33.7999C37.7378 33.4243 38.4325 33.5096 38.8081 33.9902C39.1837 34.4707 39.0984 35.1655 38.6179 35.5411C34.8612 38.4839 29.4132 38.2261 25.9535 34.7665C22.2147 31.0277 22.2147 24.9653 25.9535 21.2264C28.7749 18.4051 32.9169 17.7153 36.3876 19.1508Z",
    fill: "#1066DF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: -2,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#3749E7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: -2,
    width: 60,
    height: 60,
    rx: 30,
    stroke: "#181C2A",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1074 14.9961C69.3118 14.9961 67.8574 16.4505 67.8574 18.2461V34.4961C67.8574 38.0873 70.7662 40.9961 74.3574 40.9961H81.7877C82.1696 40.9961 82.4824 40.6873 82.4824 40.3014C82.4824 40.017 82.3118 39.7611 82.0477 39.6595C78.9765 38.4977 76.7949 35.532 76.7949 32.0545V28.8045H73.4921C73.1671 28.8045 72.9721 28.443 73.1549 28.1748L78.8952 19.5623C79.0577 19.3227 79.4112 19.3227 79.5696 19.5623L85.3099 28.1748C85.4887 28.443 85.2977 28.8045 84.9727 28.8045H81.6699V31.6483C81.6699 32.7452 82.5434 33.6714 83.6402 33.6795C88.828 33.712 93.0449 29.5155 93.0449 24.3358C93.0449 19.1561 88.8605 14.9961 83.7012 14.9961",
    fill: "white"
  })));
};
export default SvgVerifyOwnership;